export default {"src":"/_next/static/media/casa-mineira.fc5c46cd.svg","height":33,"width":34,"blurWidth":0,"blurHeight":0};